import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { usePublicSiteContent } from "../../hooks/useSiteContent";
import { whatsappUrl } from "../../lib/siteContentStore";

const navLinks = [
  { label: "Ana Sayfa", path: "/" },
  { label: "Hakkımızda", path: "/bizim" },
  { label: "Hizmetler", path: "/hizmetler" },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const content = usePublicSiteContent();

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="sticky top-0 left-0 right-0 z-50 border-b border-farm-border/80 bg-farm-warm/95 backdrop-blur-xl shadow-sm">
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between min-h-[76px]">
        <Link to="/" className="flex items-center gap-3 group cursor-pointer">
          <div className="w-12 h-12 flex items-center justify-center rounded-full overflow-hidden bg-farm-earth-light ring-1 ring-farm-earth/20 shadow-sm">
            <img
              src="https://public.readdy.ai/ai/img_res/73cf5855-ea32-42f4-956b-881be407de25.png"
              alt="Evren Çiftliği Logo"
              className="w-11 h-11 object-contain"
            />
          </div>
          <div className="leading-tight">
            <span className="block font-heading font-bold text-xl md:text-2xl text-farm-brown tracking-wide">
              EVREN ÇİFTLİĞİ
            </span>
            <span className="block font-body text-[10px] md:text-xs tracking-[0.30em] text-farm-earth font-bold">
              KURBANLIK • ADAKLIK
            </span>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-2">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`px-4 py-2 rounded-full font-body text-sm font-bold transition-colors whitespace-nowrap cursor-pointer ${
                isActive(link.path)
                  ? "bg-farm-earth-light text-farm-brown"
                  : "text-farm-muted hover:text-farm-brown hover:bg-farm-cream"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href={whatsappUrl(content)}
            rel="nofollow noopener"
            target="_blank"
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-farm-green/10 text-farm-green border border-farm-green/25 font-body text-sm font-bold hover:bg-farm-green hover:text-white transition-colors"
          >
            <i className="ri-whatsapp-line text-lg" />
            Kayıt Ol
          </a>
          <Link
            to="/giris"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-farm-brown text-white font-body text-sm font-bold hover:bg-farm-earth transition-colors shadow-sm"
          >
            <i className="ri-user-line text-lg" />
            Müşteri Girişi
          </Link>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-farm-brown hover:bg-farm-cream transition-colors"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="Menüyü aç"
        >
          <i className={`ri-${menuOpen ? "close" : "menu"}-line text-2xl`} />
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-farm-warm border-t border-farm-border px-4 pb-4 pt-2 animate-fade-in">
          <nav className="flex flex-col gap-1 mb-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMenuOpen(false)}
                className={`px-4 py-2.5 rounded-lg font-body text-sm transition-colors ${
                  isActive(link.path)
                    ? "bg-farm-earth-light text-farm-brown font-bold"
                    : "text-farm-muted hover:bg-farm-cream hover:text-farm-brown"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>
          <div className="grid grid-cols-2 gap-2">
            <a
              href={whatsappUrl(content)}
              rel="nofollow noopener"
              target="_blank"
              className="text-center px-4 py-2.5 rounded-full bg-farm-green text-white font-body text-sm font-bold"
            >
              WhatsApp
            </a>
            <Link
              to="/giris"
              onClick={() => setMenuOpen(false)}
              className="text-center px-4 py-2.5 rounded-full bg-farm-brown text-white font-body text-sm font-bold"
            >
              Giriş
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
